import { getCSRFToken } from "./htmx-helpers";

interface AddonFee {
  image_key: string;
  image_preview_url: string;
}

interface UploadCaps {
  STUDIO_CONFIG?: { uploadManager?: { uploadCaps?: Record<string, number> } };
}

/**
 * Alpine component for the fee drawer's add-on photo picker (R13). Uploads to
 * the org's add-on image endpoint and writes the returned key + preview URL
 * onto the fee row; the key is posted via the row's hidden input on autosave.
 */
export function registerAddonImageUpload(Alpine: { data: (name: string, fn: (uploadUrl: string) => object) => void }): void {
  Alpine.data("addonImageUpload", (uploadUrl: string) => ({
    uploading: false,
    error: "",
    async upload(this: { uploading: boolean; error: string; $el: HTMLElement }, event: Event, fee: AddonFee): Promise<void> {
      const input = event.target as HTMLInputElement;
      const file = input.files?.[0];
      input.value = "";
      if (!file) return;
      const cap = (globalThis as unknown as UploadCaps).STUDIO_CONFIG?.uploadManager?.uploadCaps?.addon_image;
      if (cap && file.size > cap) {
        this.error = this.$el.dataset.tooLarge ?? "";
        return;
      }
      this.uploading = true;
      this.error = "";
      try {
        const body = new FormData();
        body.append("image", file);
        const res = await fetch(uploadUrl, { method: "POST", body, headers: { "X-CSRF-Token": getCSRFToken() } });
        if (!res.ok) {
          const j = (await res.json().catch(() => null)) as { message?: string } | null;
          this.error = j?.message || this.$el.dataset.failed || "";
          return;
        }
        const j = (await res.json()) as { key: string; preview_url: string };
        fee.image_key = j.key;
        fee.image_preview_url = j.preview_url;
      } catch {
        this.error = this.$el.dataset.failed ?? "";
      } finally {
        this.uploading = false;
      }
    },
  }));
}
